// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RuleBar_wrapper__12Zsp"};